export default __webpack_public_path__ + "static/media/fish2.b6a289d1.jpeg";